import axios from "axios";
import Kjur from "../utils/jwt";

const bearerToken = Kjur.encode(
  JSON.parse(localStorage.getItem("userDetails"))
);

let axiosConfig = {
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
    "Strict-Transport-Security": "max-age=90",
    Authorization: `Bearer ${bearerToken}`,
  },
};

export const fetchVideos = async (data) => {
  const obj = {
    page: data.page,
    limit: data.limit,
    keyword: data.keyword,
    status: data.status,
  };
  
  const encodedData = Kjur.encode(obj);

  return await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/admin/discover-videos?token=${encodedData}`,
    axiosConfig
  );
};

export const fetchVideo = async (id) => {
  const data = {
    id : id
  }
  console.log(data);
  const encodedData = Kjur.encode(data);

  return await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/admin/discover-videos/show?token=${encodedData}`,
    axiosConfig
  );
};

export const addVideo = async (videoDetail) => {
  
  const data = {
    title: videoDetail.title,
    video_type: videoDetail.videoType,
    video_url: videoDetail.videoUrl,
    video_duration: videoDetail.videoDuration,
    cover_image: videoDetail.coverImage,
    description: videoDetail.description,
    status: videoDetail.isVerified ? 'verified' : videoDetail.status,
    package_id: videoDetail.packageId,
    advertised_by: videoDetail.dealerId,
    is_verified: videoDetail.isVerified ?? false,
    is_send_poster: videoDetail.isSendPoster ?? false,
    is_send_all: videoDetail.isSendAll ?? false,
  };

  const encodedData = Kjur.encode(data);

  return await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/admin/discover-videos`,
    { token: encodedData },
    axiosConfig
  );
};

export const editVideo = async (videoDetail) => {
  const data = {
      id: videoDetail.id,
      title: videoDetail.title,
      video_type: videoDetail.videoType,
      video_url: videoDetail.videoUrl,
      video_duration: videoDetail.videoDuration,
      cover_image: videoDetail.coverImage,
      description: videoDetail.description,
      status: videoDetail.isVerified ? 'verified' : videoDetail.status,
      package_id: videoDetail.packageId,
      advertised_by: videoDetail.dealerId,
      is_verified: videoDetail.isVerified ?? false,
      is_send_poster: videoDetail.isSendPoster ?? false,
      is_send_all: videoDetail.isSendAll ?? false,
    };
  
    // if(!videoDetail.isVerified) {
    //   delete data.is_verified;
    // }
    
    const encodedData = Kjur.encode(data);
  
    return await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/admin/discover-videos/update`,
      { token: encodedData },
      axiosConfig
    );
};

export const deleteVideo = async (id) => {
  const data = {
    id: id,
  };

  const encodedData = Kjur.encode(data);

  return await axios.delete(
    `${process.env.REACT_APP_API_BASE_URL}/admin/discover-videos/delete?token=${encodedData}`,
    axiosConfig
  );
};
